import { PieChart, Pie, Tooltip, Cell } from "recharts";
import React from "react";
import "../../../../../styles/ComponentsStyles/Organizational/Management/Dashboard/DonutChart.style.css";

export function DonutChart({ donutChartData }) {
  const totalAppearances = React.useMemo(() => {
    return (
      donutChartData &&
      donutChartData.reduce((acc, curr) => acc + curr.appearanceCount, 0)
    );
  }, [donutChartData]);

  return (
    <div className="donut-chart-container">
      <div className="chart-content">
        <PieChart width={250} height={250}>
          <Pie
            data={donutChartData}
            dataKey="appearanceCount"
            nameKey="participant"
            innerRadius={65}
            outerRadius={100}
            strokeWidth={3}
            labelLine={false}
            label={({ cx, cy }) => (
              <text x={cx} y={cy} textAnchor="middle" dominantBaseline="middle">
                <tspan x={cx} dy="-0.5em" className="donut-text">
                  Total Appearance
                </tspan>
                <tspan x={cx} dy="1.5em" className="donut-subtext">
                  {totalAppearances.toLocaleString()}
                </tspan>
              </text>
            )}
          >
            {donutChartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.positionColor} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </div>
    </div>
  );
}

export default DonutChart;
